import React from 'react'
import { T } from '@transifex/react'
import { Currency } from '@vend/business-components'
interface StatusBadgeProps {
  totalPendingAmountDollars: number
}

/**
 * Payment request summary card status badge
 */
export const StatusBadge: React.FC<StatusBadgeProps> = ({
  totalPendingAmountDollars,
}) => {
  return (
    <span className="vd-flag">
      <T
        _str="PENDING {amount}"
        _context="Payment requests pending badge"
        amount={<Currency value={totalPendingAmountDollars} />}
      />
    </span>
  )
}
